import {of as observableOf, Observable} from 'rxjs';

import {catchError, map} from 'rxjs/operators';
import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {DetailControl, ValuesObject} from '../detail-tabconfig';
import {ViewTabComponent} from '../viewtab.component';

@Component({
  selector: 'ctrl-label',
  template: `
    <p [class.bold]="bold | async" [class.italic]="italic | async">{{ value | async }}</p>
  `,
  styles: [
    'p {margin: 0; padding: 3px 0 7px; line-height: 1; min-height: 24px;} p.bold {font-weight: bold;} p.italic {font-style: italic;}',
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CtrlLabelComponent {
  constructor(private _parent: ViewTabComponent) {}

  value: Observable<string> = observableOf('');
  private _config: DetailControl = null;

  @Input()
  set config(conf: DetailControl) {
    if (conf != this._config && conf != null) {
      this._config = conf;
      if (!this._config.hasProperties()) {
        console.error('No Properties found in configuration!');
        console.debug(conf);
        return;
      }

      let targetObs: Observable<string> = null;

      if (this._config.propertyExists('Source')) {
        targetObs = this._config.getPropertyValues('Source');
      } else if (this._config.propertyExists('Text')) {
        targetObs = this._config.getPropertyValues('Text');
      }

      this.value = targetObs.pipe(
        map(value => (value ? value : '')),
        catchError(error => {
          if (this._config != null) {
            this._config.hasErrors = true;
          }
          this._config.Name.pipe(
            catchError((error, caught) => {
              this._parent.addControlError('Unknown Control', String(error.message));
              return observableOf('');
            }),
          ).subscribe((name: ValuesObject<string>) => {
            if (this._parent != null) {
              if (name != null && name.Values != null)
                this._parent.addControlError(name.Values, String(error.message));
              this._parent.addControlError('Unknown Control', String(error.message));
            }
          });

          return observableOf('');
        }),
      );

      if (this._config.propertyExists('TextstyleBold')) {
        this.bold = this._config.getBooleanPropertyValues('TextstyleBold');
      }

      if (this._config.propertyExists('TextstyleItalic')) {
        this.italic = this._config.getBooleanPropertyValues('TextstyleItalic');
      }
    }
  }

  bold: Observable<boolean> = observableOf(false);
  italic: Observable<boolean> = observableOf(false);
}
